import React, { Fragment } from 'react';
import { ClimbingBoxLoader } from 'react-spinners';

const MainLoader = (props) => {

    const mainStyle = {
        position: 'fixed',
        zIndex: 3,
        height: '100%',
        width: '100%',
        top: 0,
        right: 0,
        backgroundColor: '#f1f2f2',
        padding: 'calc(50vh - 53px) calc(50vw - 53px)'
    }

    return (
        <Fragment>
            {
                props.loading ?
                <div style={mainStyle}>
                    <ClimbingBoxLoader size={10} color="#136f94" id="main-loader" {...props} />
                    <p style={{textAlign: 'center', width: 110}}>Loading...</p>
                </div> : null
            }
        </Fragment>
    );
}

export default MainLoader;
